import WellForm from '../../../components/wellForm';

function CreateWell() {
  return (
    <WellForm />
  );  
}

export default CreateWell
